import { useHistory, useLocation } from "react-router-dom";

import ElasticAgents from "./ElasticAgents";
import JobFiness from "./JobFiness";
import JobStrategy from "./JobStrategy";
import ParamFeatures from "./ParamFeatures";
import ParamModules from "./ParamModules";
import ParamRepositories from "./ParamRepositories";
import ParamViews from "./ParamViews";
import React, { useState } from "react";
//import Roles from "./Roles";
import Strategy from "./Strategy";
import PageEntete, { BarreSlot, Puces } from "../utils/PageEntete";

const DEFAULT_GROUP = "deploiement";

const groups = [
  {
    key: "deploiement",
    label: "Déploiement",
    subs: [
      { key: "strategy", label: "Stratégies", children: <Strategy /> },
      { key: "jobStrategy", label: "Stratégie par job", children: <JobStrategy /> },
      { key: "jobFiness", label: "Jobs par environnement", children: <JobFiness /> },
      { key: "elasticAgents", label: "Agents Elastic", children: <ElasticAgents /> },
    ],
  },
  {
    key: "referentiels",
    label: "Référentiels",
    subs: [
      // Ordre « poupée russe » : un dépôt porte des modules, un module des fonctionnalités.
      { key: "repositories", label: "Dépôts", children: <ParamRepositories /> },
      { key: "modules", label: "Modules", children: <ParamModules /> },
      { key: "features", label: "Fonctionnalités", children: <ParamFeatures /> },
      { key: "views", label: "Vues", children: <ParamViews /> },
    ],
  },
];

// Anciens liens ?tab=<sous-onglet> : sous-onglet -> groupe.
const legacyGroup = {};
groups.forEach((g) => g.subs.forEach((s) => (legacyGroup[s.key] = g.key)));

export const resolveSelection = (search) => {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const sub = params.get("sub");
  let group = groups.find((g) => g.key === tab);
  let subKey = null;
  if (group) {
    subKey = sub;
  } else if (Object.prototype.hasOwnProperty.call(legacyGroup, tab)) {
    group = groups.find((g) => g.key === legacyGroup[tab]);
    subKey = tab;
  } else {
    group = groups.find((g) => g.key === DEFAULT_GROUP);
  }
  const found = group.subs.find((s) => s.key === subKey);
  return { group, sub: found || group.subs[0] };
};

function Settings(props) {
  const location = useLocation();
  const history = useHistory();
  const { group, sub } = resolveSelection(location.search);
  const [slot, setSlot] = useState(null);
  const go = (g, s) =>
    history.replace(`${location.pathname}?tab=${g}&sub=${s}`);

  return (
    <div className="cti-page">
      <PageEntete
        title="Configuration"
        label="Groupe"
        items={groups}
        value={group.key}
        onChange={(key) => {
          const g = groups.find((x) => x.key === key);
          go(key, g.subs[0].key);
        }}
      />
      <Puces
        label="Section"
        items={group.subs}
        value={sub.key}
        onChange={(key) => go(group.key, key)}
        extra={<span className="cti-bar-slot" ref={setSlot} />}
      />
      <BarreSlot.Provider value={slot}>
        <div className="cti-panel">{sub.children}</div>
      </BarreSlot.Provider>
    </div>
  );
}

export default Settings;
